export default __webpack_public_path__ + "static/confetti-stamps-left-large-6c2965859e2217d91518cc88cab651c6.svg";